import React from 'react';
import styled from 'styled-components';
import './MobileNavBarMenu.css';
import { useLocation, useNavigate } from 'react-router-dom';

const MobileNavBarMenu = (props) => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <div className={`fullscreen-menu`}>
      <button onClick={() => props?.toggleMenu('what-do-we-do')}>
        Solution
      </button>
      <button onClick={() => props?.toggleMenu('impact')}>Impact</button>
      <button onClick={() => navigate('/pricing')}>Plans</button>
      <button
        onClick={() => {
          if (location.pathname?.includes('resources')) {
            props?.closePoppup();
          } else {
            navigate('/resources');
          }
        }}
      >
        Resources
      </button>
      <button
        onClick={() => {
          props?.closePoppup();
          props?.openPopup(true);
        }}
      >
        Book a Demo
      </button>
    </div>
  );
};

export default MobileNavBarMenu;
